export default __webpack_public_path__ + "static/media/hypotenuse.80408c91.svg";